import React, { useState } from 'react';

import { API } from 'constants';
import client from '../../../../services/cycle-api';

import { defaultErrorMessage } from '../../../../constants/errorMessages';

import ConfirmDeletionModalPattern from '../../../../design-system/ConfirmDeletionModalPattern/ConfirmDeletionModalPattern';

const DeleteStageModal = ({ id, name, setStage, onClose, onClosePanel }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorAlert, setErrorAlert] = useState(null);

    const handleDelete = async () => {
        try {
            setIsLoading(true);

            await client.delete(API.ROUTES.cycle.cycleStage + id + '/');

            setStage((stage) => ({ ...stage, is_deleted: true }));
            onClosePanel();
        } catch (e) {
            setErrorAlert({ message: defaultErrorMessage, statusCode: e.response?.statusCode });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <ConfirmDeletionModalPattern
            title="Delete Stage?"
            handleDelete={handleDelete}
            onClose={onClose}
            isLoading={isLoading}
            confirmationTextStart="Are you sure you want to delete the"
            confirmationTextEnd="stage?"
            entityName={name}
            variant="primary"
            errorAlert={errorAlert}
            setErrorAlert={setErrorAlert}
            customConfirmButtonText="Yes, Delete"
        />
    );
};

export default DeleteStageModal;
